import { render, staticRenderFns } from "./AllocationMethodUpdate.vue?vue&type=template&id=7deeaeb1&"
import script from "./AllocationMethodUpdate.vue?vue&type=script&lang=js&"
export * from "./AllocationMethodUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AllocationMethodUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AllocationMethodUpdate.vue"
export default component.exports